import React, { Component } from 'react'
// import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import ScheduledDeliveriesRoutes from './routes'
import { BackTop } from 'antd'

import { actions as scheduledDeliveriesActions } from '../../redux/modules/scheduledDeliveriesActions'
import { actions as vehiclesActions } from '../../redux/modules/vehiclesActions'
import { actions as driverActions } from '../../redux/modules/driverActions'

const propTypes = {}

class DriversContainer extends Component {
  componentDidMount() {
    this.props.vehiclesRefresh()
    this.props.driverListRefresh()
  }
  render() {
    return (
      <div>
        <BackTop />
        <ScheduledDeliveriesRoutes />
      </div>
    )
  }
}

const mapStateToProps = (
  { authentication, scheduledDeliveriesActions, vehiclesActions, driverActions },
  ownProps
) => ({
  authentication,
  scheduledDeliveriesActions,
  vehiclesActions,
  driverActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign({}, scheduledDeliveriesActions, vehiclesActions, driverActions),
    dispatch
  )
})

DriversContainer.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DriversContainer))



// WEBPACK FOOTER //
// ./src/containers/drivers/index.js